const template_File = `/templateFiles/templates`;

export { template_File };
